import React from 'react';
import {
  Button,
  Layout,
  notification,
} from 'antd';
import * as API from 'aws-amplify/api';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { createErrorMessage } from '../../context/globalStateHelper';
import PageHeaderBar from '../../components/PageHeaderBar';
import SwaggerUI from '../../components/SwaggerUI';
import downloadFile from '../../utils/downloadFile';

const { Content } = Layout;

class ApiDocs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      swagger: null,
    };
  }

  componentDidMount = async () => {
    const { t, swaggerUrl } = this.props;

    try {
      const { body } = await API.get({
        apiName: 'FINTSO',
        path: swaggerUrl || '/swagger',
      }).response;
      const response = await body.json();
      this.setState({ swagger: response });
    } catch (e) {
      notification.error({
        className: 'notification-error',
        message: t('common.notifications.errorFetching'),
        description: await createErrorMessage(e),
      });
    }
    this.setState({ isLoading: false });
  }

  downloadOpenApi = () => {
    const { swagger } = this.state;
    // eslint-disable-next-line no-underscore-dangle
    const versionDate = window.__APP_VERSION__?.VERSION?.split('-')[0];
    const filename = `gasgridportal-openapi${versionDate ? `-${versionDate}` : ''}.json`;
    downloadFile(JSON.stringify(swagger, null, 2), filename, 'application/json');
  };

  render() {
    const { t } = this.props;
    const { isLoading, swagger } = this.state;
    return (
      <>
        <PageHeaderBar
          title="API Docs"
          actionItems={(
            <Button
              type="primary"
              disabled={isLoading || !swagger}
              onClick={this.downloadOpenApi}
            >
              {t('apiDocs.downloadOpenApiJson')}
            </Button>
          )}
        />
        <Content className="layout__container__page__content">
          {isLoading ? <div>Loading...</div> : <SwaggerUI spec={swagger} />}
        </Content>
      </>
    );
  }
}

ApiDocs.propTypes = {
  t: PropTypes.func.isRequired,
  swaggerUrl: PropTypes.string,
};

ApiDocs.displayName = 'ApiDocs';

export default withTranslation()(ApiDocs);
